export { default } from "./ViewResetPassword";
